import React, { forwardRef } from 'react'

const Container = forwardRef(({ children, className }, ref) => {
  return (
    <div
      ref={ref}
      className={`mx-auto w-full px-6 sm:px-16 lg:px-32 xl:px-80 ${className}`}
    >
      {children}
    </div>
  )
})

export default Container
